export const BASE_URL =
    process.env.REACT_APP_API_BASE_URL ?? 'https://api.dev.app.crunchyway.com';

export const AUTH_BASE_URL =
    process.env.REACT_APP_AUTH_BASE_URL ?? 'https://auth.dev.app.crunchyway.com';

export const CLIENT_ID =
    process.env.REACT_APP_CLIENT_ID ?? 'autopath-web';

export const REDIRECT_URI =
    process.env.REACT_APP_REDIRECT_URI ?? 'https://app.dev.crunchychoice.com/callback';